import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from '../../Parts/Button'
import TextField from 'material-ui/TextField';
import { validateProperty } from '../../../utils/validator'

import DialogModal from '../../common/DialogModal';

const styles = theme => ({
  paper: {
    minWidth: '450px',
  },

  input: {
    borderRadius: 2,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #D8DBDF',
    fontSize: '15px',
    padding: '10px 12px',
    width: 'calc(100% - 24px)',
    marginBottom: '24px',
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
  }
});

class EditEntryDialog extends React.Component {
  state = {
    value: this.props.value,
    error: {},
    saveBtnPressed: false,
    message: '',
  }

  componentWillReceiveProps(nextProps) {
    //close dialog when API succeeds
    if (this.props.isSaving && !nextProps.isSaving) {
      nextProps.toggleDialog();
    }

    if (!this.props.error && nextProps.error) {
      if (nextProps.error && nextProps.error.data && nextProps.error.data.message) {
        this.setState({
          message: nextProps.error.data.message,
        })
      }
    }
  }

  handleChange = (event) => {
    let value = event.target.value;

    //２回目からタイピングごとでチェック
    if (this.state.saveBtnPressed) {
      this.validateInput(this.props.type, value);
    }

    this.setState({
      value: value,
    })
  }

  handleSave = () => {
    let { error, saveBtnPressed, value } = this.state;

    if (!saveBtnPressed) error = this.validateInput(this.props.type, value);

    if (Object.keys(error).length === 0) {
      this.props.save({ [this.props.type]: value });
    } else {
      this.setState({
        saveBtnPressed: true,
      });
    }
  }

  validateInput = (p, value) => {
    let error = validateProperty(value, this.state, p);

    this.setState({
      error: error,
    });

    return error;
  };

  render() {
    const { classes, title, toggleDialog, type, isSaving } = this.props;
    const { value, error } = this.state;

    return (
      <DialogModal
        classes={{
          paper: classes.paper
        }}
        open={this.props.isOpen}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        onClose={toggleDialog}
        title={title}
      >
        <TextField
          type="text"
          margin="normal"
          InputProps={{
            disableUnderline: true,
            classes: {
              input: classes.input,
            },
          }}
          value={this.state.value}
          onChange={this.handleChange}
          error={error.hasOwnProperty(type)}
          helperText={error[type]}
          fullWidth
        />

        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={this.handleSave}
            text="保存"
            disabled={value === '' || Object.keys(error).length > 0}
            loading={isSaving}
          >
          </Button>
        </div>
      </DialogModal>
    );
  }
}

EditEntryDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  title: PropTypes.string,
  value: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  save: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
};

export default withStyles(styles)(EditEntryDialog);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Basic/EditEntryDialog.jsx